import locales from './locales/en-us.json';

export default {
  ...locales,
  app_title: 'Starter',

  locales_en_US: 'English (US)',
  locales_en_CA: 'English (CA)',
  locales_fr_CA: 'French (CA)',
  locales_es_US: 'Spanish (US)',

  languageToggle_enCA: 'English (CA)',
  languageToggle_enUS: 'English (US)',
  languageToggle_esUS: 'Español (US)',
  languageToggle_frCA: 'Français (CA)',

  actions_back: 'Back',
  actions_continue: 'Continue',

  about_pageTitle: 'About',
  home_pageTitle: 'Home Page',
  onexExamples_pageTitle: 'OneX Examples',
};
